import React from "react";
import { getField, deserializeField } from "../../util/DynamicItemUtils";

export default function Biography({ item }: any) {
  var originalUrl = getField(item, "pageurl");
  var finalUrl = originalUrl;

  switch (getField(item, "biographytypes")) {
    case "Board Member":
      break;

    case "Staff Member":
      finalUrl = originalUrl
        .replace("/about/the-board/", "/about/senior-staff/senior-staff-bios/")
        .replace("board-bios/", "");
      break;

    case "Former Board Member":
      break;
 
    default:
      finalUrl = originalUrl.replace(
        "/about/the-board/",
        "/about/senior-staff/senior-staff-bios/"
      );
      break;
  }

  return (
    <div>
      <div className="hawk-heading">
        {deserializeField(item, "pageimage") && (
          <div
            className="hawk-bio-image"
            style={{
              backgroundImage:
                "url(" + deserializeField(item, "pageimage")[0].mediaUrl + ")",
            }}
          >
            <img
              src={deserializeField(item, "pageimage")[0].mediaUrl}
              className="visually-hidden"
              alt={deserializeField(item, "pageimage")[0].title}
            />
          </div>
        )}
        <div>
          <p className="lead-text-lt">Biography</p>
          <h3>
            <a href={finalUrl}>{getField(item, "title")}</a>
          </h3>

          {getField(item, "biographytypes") && (
            <div className="hawk-column">
              <div className="lead-text-lt">Position</div>
              <div className="lead-text-st">
                {getField(item, "biographytypes")}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="hawk-row">
        <div className="hawk-row">
          {getField(item, "JobTitle") && (
            <div className="hawk-column">
              <div className="lead-text-lt">JobTitle</div>
              <div className="lead-text-st">{getField(item, "JobTitle")}</div>
            </div>
          )}
          {getField(item, "company") && (
            <div className="hawk-column">
              <div className="lead-text-lt">Company</div>
              <div className="lead-text-st">{getField(item, "company")}</div>
            </div>
          )}
          {getField(item, "divisions") && (
            <div className="hawk-column">
              <div className="lead-text-lt">Divisions</div>
              <div className="lead-text-st">{getField(item, "divisions")}</div>
            </div>
          )}
        </div>
      </div>
      <div className="hawk-row">
        {getField(item, "summary") && (
          <div className="hawk-column">
            <div className="hawk-summary-text">{getField(item, "summary")}</div>
          </div>
        )}
      </div>
      <a href={finalUrl} className="hawk-read-more">
        Read More
      </a>
    </div>
  );
}
